import useQuery from './useQuery'
import { filterEmptyValues } from 'utils/helpers'

/**
 * Drives an always-visible, auto-applying log filter bar.
 *
 * All of a log's filters live under a single URL query key (e.g.
 * `talabatLogFilters`) as a JSON object — the same shape the table and the
 * Clear button already read. `setField` does a read-modify-write of that
 * object and resets pagination, so each control applies the moment it changes.
 */
const useLogFilters = (filterKey: string) => {
  const { getQuery, removeQuery, setMultipleQueries } = useQuery()

  const filters: Record<string, string> = getQuery(filterKey) || {}

  const setField = (field: string, value: string) => {
    const isClear = !value || value === 'NONE'
    const current = filters[field]

    // No-op guard: prevents spurious navigations (e.g. the Dropdown firing its
    // initial setValue on mount) and redundant refetches.
    if (isClear && current === undefined) return
    if (!isClear && current === value) return

    const next = { ...filters }
    if (isClear) {
      delete next[field]
    } else {
      next[field] = value
    }

    const cleaned = filterEmptyValues(next)
    if (Object.keys(cleaned).length > 0) {
      setMultipleQueries({ [filterKey]: cleaned, page: 1 })
    } else {
      removeQuery(filterKey)
    }
  }

  return { filters, setField }
}

export default useLogFilters
